import {PhoneHQGlyph} from 'ch3-ui-lib';
import { useAuthenticatedMedia } from "../../hooks/useAuthenticatedMedia";
import PHQAudioPlayer from "../AudioPlayer/PhoneHqAudioPlayer.tsx";
import type { MatrixEncryptedFile } from "../../utils/encryptedMedia";

interface AuthenticatedAudioProps {
    src: string;
    className?: string;
    style?: React.CSSProperties;
    controls?: boolean;
    autoPlay?: boolean;
    muted?: boolean;
    loop?: boolean;
    preload?: 'none' | 'metadata' | 'auto';
    encryptedFile?: MatrixEncryptedFile;
    mimeType?: string;
    showSpeedControl?: boolean;
}

export const AuthenticatedAudio = ({
                                        src,
                                        className,
                                        style,
                                        encryptedFile,
                                        mimeType,
                                        showSpeedControl,
                                    }: AuthenticatedAudioProps) => {
    const { blobUrl, isLoading, error, retry } = useAuthenticatedMedia(src, encryptedFile, mimeType);

    if (isLoading) {
        return (
            <div className={`h-20 flex items-center justify-center bg-surface-muted rounded-lg p-4 ${className}`} style={style}>
                <div className="flex items-center space-x-3">
                    <PhoneHQGlyph name="refresh" size={24} className="animate-spin text-ink-muted"/>
                    <span className="text-sm text-ink-muted">Loading audio...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`flex items-center justify-center bg-surface-muted rounded-lg p-4 ${className}`} style={style}>
                <div className="flex items-center space-x-3 min-w-0">
                    <PhoneHQGlyph name="volume_off" size={24} className="text-ink-muted"/>
                    <span
                        className="text-sm text-ink-muted break-words min-w-0"
                        title={error}
                    >
                        Failed to load audio: {error}
                    </span>
                    <button
                        type="button"
                        onClick={retry}
                        className="flex-shrink-0 inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                        title="Try loading the audio again"
                    >
                        <PhoneHQGlyph name="refresh" size={16}/>
                        Try again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={className}>
            <PHQAudioPlayer
                src={blobUrl}
                showSpeedControl={showSpeedControl}
            />
        </div>

    );
};
